<template>
    <section class="VibeCommonProfilesListBlock container relative pt-8 max-sm:pt-20">
        <slot name="image" />
        <header class="pb-16 text-center text-5xl font-semibold leading-none text-[#282828]">
            <h2><slot /></h2>
        </header>

        <!-- TODO: Add MentoringSlider component after slider migration -->
        <!-- <div class="disable-clicks">
            <MentoringSlider :filters="filters" fixed-width in-new-tab :min-count="1" :variant="variant" />
        </div> -->
    </section>
</template>

<script setup lang="ts">
// import MentoringSlider from '@/components/mentoring/MentoringSlider.vue'

defineProps({
    variant: {
        type: String,
        required: true
    }
})

// const filters = ref({ interests: ['vibe'] })
</script>

<style lang="postcss" scoped>
.disable-clicks :deep(a) {
    pointer-events: none;
    cursor: default;
    text-decoration: none;
}
</style>
